const SectionCont1 = () => {
	return (
		<section className="sub-content cont1">
			<div className="sub-inner">
				<div className="title-group">
					<p className="title">
						<span>타사 ERP 대비 스텔라의 3가지 결정적 차이</span>
					</p>
				</div>
				<ul className="main-list">
					<li className="yellow">
						<span className="index">01</span>
						<span className="badge"></span>
						<div className="text-wrap">
							<span className="text-wrap_badge">타사 기본 미제공/유료</span>
							<strong className="text-wrap_title">무료 제공 4대 프리미엄 기능</strong>
							<p className="text-wrap_desc">
								타사 ERP 기본 패키지에는 없는 핵심 경영 관리
								<br />
								기능을 모두 기본으로 제공합니다.
							</p>
						</div>
						<ul className="sub-list">
							<li>거래처 신용 정보 관리</li>
							<li>실시간 경영리포트 </li>
							<li>재고 관리</li>
							<li>영업 관리</li>
						</ul>
					</li>
					<li className="pink">
						<span className="index">02</span>
						<span className="badge"></span>
						<div className="text-wrap">
							<span className="text-wrap_badge">비용절감</span>
							<strong className="text-wrap_title">압도적 비용 경쟁력</strong>
							<strong className="text-wrap_title point-color">
								연간 782만원 절감<span>(예시) 20인 기업 기준</span>
							</strong>
						</div>
						<ul className="sub-list">
							<li>
								스텔라는 사용자 무제한
								<br />연 70만원(월 7만원)
							</li>
							<li>타사 대비 1/10 이상 저렴한 비용</li>
							<li>인원 증가시 추가비용 0원</li>
						</ul>
					</li>
					<li className="red">
						<span className="index">03</span>
						<span className="badge"></span>
						<div className="text-wrap">
							<span className="text-wrap_badge">리스크 제로</span>
							<strong className="text-wrap_title">2개월 무료 체험</strong>
						</div>
						<ul className="sub-list">
							<li>
								전체 기능 무료 제공
								<p>인원·모듈 제한 없음</p>
							</li>
							<li>
								위약금 ·해지 수수료 없음
								<p>부담 없는 자유로운 테스트</p>
							</li>
							<li>
								기존 시스템과 병행 가능
								<p>중단 없는 데이터 검증 지원</p>
							</li>
							<li>
								데이터 이관 무료 지원
								<p>타사 ERP 데이터 신속 전환</p>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</section>
	);
};

export default SectionCont1;
